export const styles = {
  container: {
    height: '100%',
    position: 'relative',
  },
};
